import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div
        className={
          "mx-auto mb-[10px] mt-[30px] flex flex-row flex-wrap justify-start gap-x-[10px] text-sm text-zinc-400"
        }
      >
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy/"
        >
          Privacy Policy
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/about-nvidia/privacy-center/"
        >
          Your Privacy Choices
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://developer.nvidia.com/legal/terms"
        >
          Terms of Use
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/about-nvidia/accessibility/"
        >
          Accessibility
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/about-nvidia/company-policies/"
        >
          Corporate Policies
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/product-security/"
        >
          Product Security
        </a>
        <p> | </p>
        <a
          className="hover:text-primary"
          href="https://www.nvidia.com/en-us/contact/"
        >
          Contact
        </a>
      </div>
      <p className={"text-xs font-light text-zinc-400"}>
        Copyright &copy; {new Date().getFullYear()} NVIDIA Corporation
      </p>
    </footer>
  );
};

export default Footer;
